import { render, staticRenderFns } from "./GoodsBuyForm.vue?vue&type=template&id=d5f5cbac&scoped=true"
import script from "./GoodsBuyForm.vue?vue&type=script&lang=js"
export * from "./GoodsBuyForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsBuyForm.vue?vue&type=style&index=0&id=d5f5cbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f5cbac",
  null
  
)

export default component.exports